// extracted by mini-css-extract-plugin
export default {"cont":"NoDataComponent_cont__E3zOa","table":"NoDataComponent_table__u8Fbo"};